import type { LinkItem } from '@ps/isp-web-services-types';

import { defaultState } from './defaultState';

type State = typeof defaultState;

export const reducers = {
  featuredMenuRequested: (state: State): State => ({
    ...state,
    isLoading: true
  }),
  clear: (): State => ({
    ...defaultState
  }),
  dataLoadSuccess: (state: State, payload: LinkItem[]): State => ({
    menuItems: payload,
    isLoading: false,
    errorCode: undefined,
    preloaded: true
  }),
  dataLoadFailed: (state: State, payload: string): State => ({
    ...state,
    isLoading: false,
    errorCode: payload,
    preloaded: true
  })
};
